<!-- MitreDrawer.vue -->
<template>
  <el-drawer
    v-model="localVisible"
    title="MITRE ATT&CK™ 技术点"
    :size="'80%'"
    :close-on-click-modal="false"
    @close="handleClose"
    custom-class="aaa"
    append-to-body
  >
    <div class="mitreAttck-wrap">
      <el-checkbox v-model="showAll" class="check">展示命中技术点</el-checkbox>
    </div>
    <PerfectScrollbar
      class="mitre-table-wrap"
      ref="scrollbar"
      :settings="{ suppressScrollX: false, suppressScrollY: false, wheelPropagation: false, minScrollbarLength: 50, maxScrollbarLength: 200 }"
      @ps-scroll-y="handleScrollY"
      @ps-scroll-x="handleScrollX"
    >
      <table class="mitre-table">
        <tr class="mitre-table-header" v-if="sigsLen > 0 || !showAll">
          <th v-for="(v, index) in mitre" :key="index" class="mitre-th">{{ v.name }}</th>
        </tr>
        <tr class="mitre-table-row" v-for="(i, rowIndex) in mitreMaxLen" :key="rowIndex">
          <td
            :class="[
              'mitre-table-col',
              {
                'match': item.attack_list.length > rowIndex && sigs[item.attack_list[rowIndex].attackid],
                'sub-technique': item.attack_list.length > rowIndex && item.attack_list[rowIndex].attackid.includes('.'),
                'unmatch-with-border': !showAll && item.attack_list.length > rowIndex && !sigs[item.attack_list[rowIndex].attackid] && (item.attack_list[rowIndex].attackid.includes('.') || expandedParents[getUniqueKey(item, rowIndex)]),
                'has-blue': item.attack_list.length > rowIndex && tagCalc(item.attack_list[rowIndex].attackid).blue > 0,
                'has-warning': item.attack_list.length > rowIndex && tagCalc(item.attack_list[rowIndex].attackid).warning > 0,
                'has-error': item.attack_list.length > rowIndex && tagCalc(item.attack_list[rowIndex].attackid).error > 0,
                'has-sub-technique': item.attack_list.length > rowIndex && !item.attack_list[rowIndex].attackid.includes('.') && hasSubTechnique(item, rowIndex),
                'highest-error': item.attack_list.length > rowIndex && !item.attack_list[rowIndex].attackid.includes('.') && getHighestSeverity(item.attack_list[rowIndex].attackid) === 'error',
                'highest-warning': item.attack_list.length > rowIndex && !item.attack_list[rowIndex].attackid.includes('.') && getHighestSeverity(item.attack_list[rowIndex].attackid) === 'warning',
                'highest-blue': item.attack_list.length > rowIndex && !item.attack_list[rowIndex].attackid.includes('.') && getHighestSeverity(item.attack_list[rowIndex].attackid) === 'blue',
                'sub-highest-error': item.attack_list.length > rowIndex && item.attack_list[rowIndex].attackid.includes('.') && getSubTechniqueHighestSeverity(item.attack_list[rowIndex].attackid.split('.')[0]) === 'error',
                'sub-highest-warning': item.attack_list.length > rowIndex && item.attack_list[rowIndex].attackid.includes('.') && getSubTechniqueHighestSeverity(item.attack_list[rowIndex].attackid.split('.')[0]) === 'warning',
                'sub-highest-blue': item.attack_list.length > rowIndex && item.attack_list[rowIndex].attackid.includes('.') && getSubTechniqueHighestSeverity(item.attack_list[rowIndex].attackid.split('.')[0]) === 'blue'
              }
            ]"
            v-for="(item, colIndex) in showAttckMitre"
            :key="colIndex"
            @click="item.attack_list[rowIndex] && attckClick(item.attack_list[rowIndex])"
          >
            <!-- 命中技术点 -->
            <span v-if="item.attack_list.length > rowIndex && item.attack_list[rowIndex] && sigs[item.attack_list[rowIndex].attackid]">
              <span v-if="!item.attack_list[rowIndex].attackid.includes('.') && getSubTechniqueCount(item.attack_list[rowIndex].attackid).t > 0" class="name-wrapper">
                <span class="name-text">{{ item.attack_list[rowIndex].name }}</span>
                <span class="sub-technique-count">({{ getSubTechniqueCount(item.attack_list[rowIndex].attackid).c }}/{{ getSubTechniqueCount(item.attack_list[rowIndex].attackid).t }})</span>
              </span>
              <span v-else>
                {{ item.attack_list[rowIndex].name }}
              </span>
              <div class="tagWrapper" :class="{bottom: item.attack_list.length > rowIndex && shouldShowArrow(item, rowIndex)}">
                <template v-for="(c, x) in tagCalc(item.attack_list[rowIndex].attackid)">
                  <span v-if="c !== 0" :key="x" :class="`flag-${x}`">{{ c }}</span>
                </template>
              </div>
            </span>
            <!-- 未命中技术点 -->
            <span v-else>
              <span v-if="item.attack_list.length > rowIndex && item.attack_list[rowIndex] && !item.attack_list[rowIndex].attackid.includes('.') && getSubTechniqueCount(item.attack_list[rowIndex].attackid).t > 0" class="name-wrapper">
                <span class="name-text">{{ item.attack_list[rowIndex].name }}</span>
                <span class="sub-technique-count">({{ getSubTechniqueCount(item.attack_list[rowIndex].attackid).c }}/{{ getSubTechniqueCount(item.attack_list[rowIndex].attackid).t }})</span>
              </span>
              <span v-else>
                {{ item.attack_list.length > rowIndex && item.attack_list[rowIndex] ? item.attack_list[rowIndex].name : '' }}
              </span>
            </span>
            <div
              v-if="item.attack_list.length > rowIndex && shouldShowArrow(item, rowIndex)"
              class="arrow-wrapper"
              :class="{ 'expanded': expandedParents[getParentKey(item, rowIndex)] }"
              @click.stop="toggleSubTechniques(item, rowIndex)"
            >
            </div>
          </td>
        </tr>
      </table>
    </PerfectScrollbar>
    <MitreDetailDialog
      :visible="mitreShow"
      :attack="attck"
      :sigs="sigs"
      :loading="loading"
      :show-detail="showDetail"
      @update:visible="mitreShow = $event"
      @update:showDetail="showDetail = $event"
    />
  </el-drawer>
</template>

<script>
import { ref } from 'vue'
import { PerfectScrollbar } from 'vue3-perfect-scrollbar'
import { isZh } from 'app/i18n'
import { getAttackInfo } from 'services/report'
import MitreDetailDialog from 'components/report/MitreDetailDialog.vue'

export default {
  name: 'MitreDrawer',
  components: {
    PerfectScrollbar,
    MitreDetailDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    behaviorfeature: {
      type: Object,
      required: true
    },
    taskId: {
      type: String,
      required: true
    },
    mitre: {
      type: Array,
      required: true
    }
  },
  setup() {
    const scrollbar = ref(null)
    return { scrollbar }
  },
  data() {
    return {
      showAll: false,
      mitreShow: false,
      showDetail: false,
      loading: false,
      attck: {},
      localVisible: this.visible,
      expandedParents: {},
      isProgrammaticScroll: false
    }
  },
  watch: {
    visible(v) {
      this.localVisible = v
    },
    localVisible(v) {
      this.$emit('update:visible', v)
    },
    showAll(newVal) {
      if (newVal) {
        this.expandedParents = {}
      }
    },
    showAttckMitre: {
      handler() {
        this.$nextTick(() => {
          if (this.scrollbar) {
            this.scrollbar.update() // 更新 PerfectScrollbar
          }
        })
      },
      deep: true
    }
  },
  computed: {
    signatures() {
      return this.behaviorfeature.signatures
    },
    sigs() {
      const ret = {}
      if (this.signatures) {
        this.signatures.forEach((ele) => {
          if (ele.attackid && ele.attackid !== ' ') {
            ele.attackid.split(',').forEach((id) => {
              const trimmedId = id.trim()
              if (ret[trimmedId] === undefined) {
                ret[trimmedId] = []
              }
              let techName = ''
              this.mitre.forEach(tactic => {
                const foundTech = tactic.attack_list.find(tech => tech.attackid === trimmedId)
                if (foundTech) {
                  techName = foundTech.name
                }
              })
              ret[trimmedId].push({
                id: trimmedId,
                desc: isZh() ? ele.descripzhcn : ele.description,
                severity: ele.severity,
                name: techName
              })
              if (trimmedId.includes('.')) {
                const parentId = trimmedId.split('.')[0]
                if (ret[parentId] === undefined) {
                  ret[parentId] = []
                }
                ret[parentId].push({
                  id: trimmedId,
                  desc: isZh() ? ele.descripzhcn : ele.description,
                  severity: ele.severity,
                  name: techName
                })
              }
            })
          }
        })
      }
      return ret
    },
    groupedSigs() {
      if (!this.attck.attackid || !this.sigs[this.attck.attackid]) {
        return []
      }
      const groupedMap = new Map()
      this.sigs[this.attck.attackid].forEach(item => {
        const key = item.id
        if (!groupedMap.has(key)) {
          groupedMap.set(key, {
            id: item.id,
            name: item.name,
            descriptions: []
          })
        }
        groupedMap.get(key).descriptions.push({
          desc: item.desc,
          severity: item.severity
        })
      })
      const groupedItems = Array.from(groupedMap.values())
      return groupedItems.sort((a, b) => {
        const aIsSub = a.id.includes('.')
        const bIsSub = b.id.includes('.')
        if (!aIsSub && bIsSub) return -1
        if (aIsSub && !bIsSub) return 1
        return a.id.localeCompare(b.id)
      })
    },
    sigsLen() {
      const uniqueIds = new Set(Object.keys(this.sigs).filter(id => !id.includes('.')))
      Object.keys(this.sigs).forEach(id => {
        if (id.includes('.')) {
          uniqueIds.add(id)
        }
      })
      return uniqueIds.size
    },
    mitreMaxLen() {
      return this.showAttckMitre
        .map((item) => item.attack_list.length)
        .reduce((prev, cur) => Math.max(prev, cur), 0)
    },
    showAttckMitre() {
      return this.mitre.map((tactic) => {
        const attackList = [...(tactic.attack_list || [])]
        const attackMap = new Map()
        attackList.forEach((tech) => {
          let techName = tech.name
          if (tech.attackid.includes('.')) {
            techName = tech.name.includes('：') ? tech.name.split('：')[1].trim() : tech.name
          }
          attackMap.set(tech.attackid, { ...tech, name: techName })
        })

        const newAttackList = []
        const parentToSubTechniques = new Map()

        attackList.forEach((tech) => {
          const techId = tech.attackid
          if (!techId.includes('.')) {
            if (this.showAll) {
              if (this.sigs[techId]) {
                newAttackList.push(attackMap.get(techId))
              }
            } else {
              newAttackList.push(attackMap.get(techId))
            }

            const subTechniques = []
            attackList.forEach((subTech) => {
              const subTechId = subTech.attackid
              if (subTechId.includes('.') && subTechId.startsWith(techId + '.')) {
                subTechniques.push(attackMap.get(subTechId))
              }
            })
            parentToSubTechniques.set(techId, subTechniques)

            subTechniques.sort((a, b) => a.attackid.localeCompare(b.attackid))

            const hitSubTechniques = subTechniques.filter(sub => this.sigs[sub.attackid])
            const unHitSubTechniques = subTechniques.filter(sub => !this.sigs[sub.attackid])

            if (this.showAll) {
              hitSubTechniques.forEach(sub => newAttackList.push(sub))
            } else {
              const parentKey = `${tactic.tacticid}_${techId}`
              if (this.expandedParents[parentKey]) {
                hitSubTechniques.forEach(sub => newAttackList.push(sub))
                unHitSubTechniques.forEach(sub => newAttackList.push(sub))
              } else {
                hitSubTechniques.forEach(sub => newAttackList.push(sub))
              }
            }
          }
        })

        return {
          ...tactic,
          attack_list: newAttackList,
          parentToSubTechniques
        }
      })
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    hasSubTechnique(item, rowIndex) {
      if (rowIndex + 1 >= item.attack_list.length) return false
      const currentTechId = item.attack_list[rowIndex].attackid
      const nextTechId = item.attack_list[rowIndex + 1].attackid
      return !currentTechId.includes('.') && nextTechId.includes('.') && nextTechId.startsWith(currentTechId + '.')
    },
    getUniqueKey(item, rowIndex) {
      return `${item.tacticid}_${item.attack_list[rowIndex].attackid}`
    },
    getParentKey(item, rowIndex) {
      const techId = item.attack_list[rowIndex].attackid
      const parentId = techId.includes('.') ? techId.split('.')[0] : techId
      return `${item.tacticid}_${parentId}`
    },
    getSubTechniqueCount(parentId) {
      const subTechniqueIds = new Set()
      const hitSubTechniqueIds = new Set()

      this.mitre.forEach(tactic => {
        tactic.attack_list.forEach(tech => {
          if (tech.attackid.includes('.') && tech.attackid.startsWith(parentId + '.')) {
            subTechniqueIds.add(tech.attackid)
          }
        })
      })

      Object.keys(this.sigs).forEach(subId => {
        if (subId.includes('.') && subId.startsWith(parentId + '.')) {
          hitSubTechniqueIds.add(subId)
        }
      })

      return {
        c: hitSubTechniqueIds.size,
        t: subTechniqueIds.size
      }
    },
    getHighestSeverity(id) {
      const counts = this.tagCalc(id, true)
      if (counts.error > 0) return 'error'
      if (counts.warning > 0) return 'warning'
      if (counts.blue > 0) return 'blue'
      return null
    },
    getSubTechniqueHighestSeverity(parentId) {
      const subTags = this.tagCalc(parentId, true)
      if (subTags.error > 0) return 'error'
      if (subTags.warning > 0) return 'warning'
      if (subTags.blue > 0) return 'blue'
      return null
    },
    attckClick(t) {
      this.mitreShow = true
      this.loading = true
      getAttackInfo({
        id: t.id,
        attackid: t.attackid,
        taskid: this.taskId
      }).then(res => {
        this.loading = false
        this.showDetail = true
        this.attck = res
      }).catch(err => {
        this.loading = false
        this.mitreShow = false
        console.error('Failed to fetch attack info:', err)
        this.$message.error('Failed to load ATT&CK details')
      })
    },
    tagCalc(id, includeSubTechniques = false) {
      const ret = {
        blue: 0,
        warning: 0,
        error: 0
      }

      if (this.sigs && this.sigs[id]) {
        this.sigs[id].forEach(function(ele) {
          if (ele.id === id) {
            if (ele.severity === 1) {
              ret.blue++
            } else if (ele.severity === 2) {
              ret.warning++
            } else if (ele.severity >= 3) {
              ret.error++
            }
          }
        })
      }

      if (!id.includes('.') && (includeSubTechniques || (this.sigs && this.sigs[id]))) {
        Object.keys(this.sigs).forEach((subId) => {
          if (subId.startsWith(id + '.')) {
            this.sigs[subId].forEach((ele) => {
              if (ele.severity === 1) {
                ret.blue++
              } else if (ele.severity === 2) {
                ret.warning++
              } else if (ele.severity >= 3) {
                ret.error++
              }
            })
          }
        })
      }

      return ret
    },
    toggleSubTechniques(item, rowIndex) {
      if (!this.showAll) {
        const techId = item.attack_list[rowIndex].attackid
        const uniqueKey = this.getUniqueKey(item, rowIndex)
        let parentKey

        if (techId.includes('.')) {
          const parentId = techId.split('.')[0]
          parentKey = `${item.tacticid}_${parentId}`
        } else {
          parentKey = uniqueKey
        }

        this.expandedParents[parentKey] = !this.expandedParents[parentKey]
      }
    },
    shouldShowArrow(item, rowIndex) {
      if (this.showAll) return false

      const techId = item.attack_list[rowIndex].attackid
      const isParent = !techId.includes('.')
      const subTechniques = item.parentToSubTechniques.get(techId) || []

      if (isParent) {
        const hitSubTechniques = subTechniques.filter(sub => this.sigs[sub.attackid]).length
        const totalSubTechniques = subTechniques.length
        return totalSubTechniques > 0 && hitSubTechniques === 0
      } else {
        const parentId = techId.split('.')[0]
        const subTechniquesForParent = item.parentToSubTechniques.get(parentId) || []
        const hitSubs = subTechniquesForParent.filter(sub => this.sigs[sub.attackid])
        const totalSubTechniques = subTechniquesForParent.length
        const hitSubTechniques = hitSubs.length

        if (hitSubTechniques === 0 || hitSubTechniques === totalSubTechniques) {
          return false
        }

        const lastHitSubId = hitSubs[hitSubs.length - 1].attackid
        return this.sigs[techId] && techId === lastHitSubId
      }
    },
    handleScrollY(event) {
      // 可选：处理纵向滚动（例如加载更多）
      console.log('Vertical scroll:', event.target.scrollTop)
    },
    handleScrollX(event) {
      if (this.isProgrammaticScroll) return
      const eventWrap = this.scrollbar?.$el
      if (!eventWrap) return
      const scrollLeft = eventWrap.scrollLeft
      const maxScrollLeft = eventWrap.scrollWidth - eventWrap.clientWidth
      const thumb = eventWrap.querySelector('.ps__thumb-x')
      if (thumb) {
        const thumbWidth = parseFloat(getComputedStyle(thumb).width)
        const railWidth = eventWrap.clientWidth
        const scrollRatio = maxScrollLeft > 0 ? scrollLeft / maxScrollLeft : 0
        thumb.style.left = `${scrollRatio * (railWidth - thumbWidth)}px`
      }
    },
    scrollToColumn(colIndex) {
      const eventWrap = this.scrollbar?.$el
      if (eventWrap) {
        const th = eventWrap.querySelectorAll('.mitre-th')[colIndex]
        if (th) {
          this.isProgrammaticScroll = true
          eventWrap.scrollTo({
            left: th.offsetLeft - eventWrap.offsetLeft,
            behavior: 'instant'
          })
          setTimeout(() => {
            this.isProgrammaticScroll = false
          }, 0)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/common.scss';

.mitreAttck-wrap {
  color: var(--color-text-1);
  font-size: 14px;
  padding: 0 0 12px;
}

.mitre-table-wrap {
  width: 100%;
  height: calc(100% - 44px);
  // max-height: 400px;
  position: relative;
  overflow: hidden;

  .ps__rail-x {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.1);
    height: 12px;
    opacity: 1;
    transition: opacity 0.2s;
  }

  .ps__thumb-x {
    background: #00ab7a;
    border-radius: 6px;
    height: 8px;
    transition: height 0.2s;

    &:hover {
      height: 10px;
    }
  }

  .ps__rail-y {
    z-index: 500;
    background: rgba(0, 0, 0, 0.1);
  }

  .ps__thumb-y {
    background: #00ab7a;
    border-radius: 6px;
    width: 8px;

    &:hover {
      width: 10px;
    }
  }

  @media (max-width: 1366px) {
    .ps__rail-x {
      height: 14px;
    }
    .ps__thumb-x {
      height: 10px;
      &:hover {
        height: 12px;
      }
    }
    .ps__rail-y {
      width: 14px;
    }
    .ps__thumb-y {
      width: 10px;
      &:hover {
        width: 12px;
      }
    }
  }
}

.mitre-table {
  border-collapse: collapse;
  min-width: 100%;
  width: fit-content;
  table-layout: fixed;

  .mitre-table-header {
    .mitre-th {
      width: 84px;
      height: 40px;
      font-size: 12px;
      color: var(--color-text-2);
      background: var(--color-bg-3);
      border: 1px solid var(--color-border-2);
      font-weight: 400;
    }
  }

  .mitre-table-row {
    .mitre-table-col {
      width: 84px;
      height: 66px;
      border: 1px solid var(--color-border-2);
      color: var(--color-text-3);
      font-size: 12px;
      vertical-align: top;
      padding: 8px;
      box-sizing: border-box;
      line-height: 16px;
      position: relative;
      word-wrap: break-word;

      &.match {
        color: var(--color-text-1);
        cursor: pointer;
        font-weight: 500;

        &:not(.sub-technique) {
          position: relative;
          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: -1px;
            width: 5px;
            height: 100%;
            background: #00ab7a;
            // z-index: 1;
          }
          &.has-warning::before {
            background: #e69f32;
          }
          &.has-error::before {
            background: #ff5967;
          }
          &.highest-error {
            background: var(--attck-error-bg);
          }
          &.highest-warning {
            background: var(--attck-warn-bg);
          }
          &.highest-blue {
            background: var(--attck-blue-bg);
          }
          &::before {
            height: calc(100% + 2px);
            top: -1px;
            clip-path: polygon(0 0, 100% 0, 100% calc(100% - 3px), 0 100%);
          }
          .name-wrapper {
            display: inline;
          }
          .name-text {
            white-space: normal;
          }
          .sub-technique-count {
            display: inline-block;
            white-space: nowrap;
            font-size: 12px;
            vertical-align: middle;
            font-weight: 500;
          }
        }

        &.sub-technique {
          position: relative;
          &::before {
            content: '';
            position: absolute;
            top: -1px;
            left: -1px;
            width: 2px;
            height: calc(100% + 1px);
            background: #00ab7a;
            // z-index: 1;
          }
          &.sub-highest-error::before {
            background: #ff5967;
          }
          &.sub-highest-warning::before {
            background: #e69f32;
          }
          &.sub-highest-blue::before {
            background: #00ab7a;
          }
          &.sub-highest-error {
            background: var(--attck-error-sub-bg);
          }
          &.sub-highest-warning {
            background: var(--attck-warn-sub-bg);
          }
          &.sub-highest-blue {
            background: var(--attck-blue-sub-bg);
          }
          font-weight: normal;
          .tagWrapper {
            font-style: normal;
          }
        }
      }

      &.unmatch-with-border {
        cursor: pointer;
        &:hover {
          background: #E8ECEF;
        }
        &:not(.sub-technique) {
          background: var(--attck-unmatch-with-border);
          position: relative;
          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: -1px;
            width: 5px;
            height: 100%;
            background: #AEB2B8;
          }
          &::before {
            height: calc(100% + 2px);
            top: -1px;
            clip-path: polygon(0 0, 100% 0, 100% calc(100% - 3px), 0 100%);
          }
          span {
            color: var(--color-text-1);
          }
        }
        &.sub-technique {
          background: var(--attck-unmatch-with-border-sub);
          position: relative;
          &::before {
            content: '';
            position: absolute;
            top: -1px;
            left: -1px;
            width: 2px;
            height: calc(100% + 1px);
            background: #AEB2B8;
          }
          padding-left: 8px;
        }
      }

      .tagWrapper {
        position: absolute;
        bottom: 4px;
        right: 7px;
        &.bottom {
          bottom: 10px !important;
        }
      }
      .flag-blue, .flag-warning, .flag-error {
        display: inline-block;
        width: 14px;
        height: 14px;
        font-size: 10px;
        font-weight: normal;
        color: #fff;
        text-align: center;
        line-height: 14px;
        border-radius: 2px;
        &+[class^="flag-"] {
          margin-left: 4px;
        }
      }
      .flag-blue {
        background: #00ab7a;
      }
      .flag-warning {
        background: #e69f32;
      }
      .flag-error {
        background: #ff5967;
      }

      .arrow-wrapper {
        position: absolute;
        bottom: -1px;
        left: 0;
        width: 100%;
        height: 8px;
        cursor: pointer;
        font-size: 12px;
        color: var(--color-text-3);
        background-image: var(--arrow-down);
        background-repeat: no-repeat;
        background-position: center;
        background-size: 22px 8px;
        &:hover {
          background-image: var(--arrow-down-hover);
        }
        &.expanded {
          background-image: var(--arrow-up);
          &:hover {
            background-image: var(--arrow-up-hover);
          }
        }
        &:hover {
          color: var(--color-text-1);
        }
      }

      &.sub-technique {
        .arrow-wrapper {
          // left: calc(50% + 7px);
        }
      }
    }
  }
}
</style>
